<div
    class="agpr-discoverListFilter"
    role="group"
    aria-describedby="dataSource_errors"
>
    <agpr-filter-include-exclude
        class="agpr-discoverListFilter-filterIncludeExclude"
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <agpr-dropdown
        [id]="id + '_listType'"
        class="agpr-discoverListFilter-dropdown"
        [options]="discoverListTypeOptions"
        [(ngModel)]="selectedListType"
        [bindToValue]="true"
        (ngModelChange)="selectListType()"
    ></agpr-dropdown>
    <agpr-autocomplete
        [id]="id + '_list'"
        class="agpr-discoverListFilter-autocomplete"
        [ngClass]="{'agpr-discoverListFilter-autocomplete--disabled' : selectedListType === discoverListTypes.none}"
        labelField="name"
        [placeholder]="selectedListType !== discoverListTypes.none ? ('Discover.listPicker.placeholder.' + selectedListType) : null"
        [dropdown]="true"
        [disabled]="selectedListType === discoverListTypes.none"
        [(ngModel)]="selectedList"
        (itemSelected)="selectSource($event)"
        [suggestions]="source$"
        tooltipPosition="top"
        selectedItemsHideKey="id"
        [ariaLabel]="'Discover.listPicker.placeholder.' + selectedListType"
        [showHiddenOption]="true"
        [clearOnBlur]="false"
    ></agpr-autocomplete>
    @if (selectedListType !== discoverListTypes.none) {
        <agpr-checkbox
            [id]="id + '_searchOutlets'"
            class="agpr-discoverListFilter-checkbox"
            [label]="selectedListType === discoverListTypes.distribution ? 'Discover.listPicker.searchRecipientOutlets' : 'Discover.listPicker.searchAssociatedOutlets'"
            [infoCircleTooltip]="selectedListType === discoverListTypes.distribution? 'Discover.listPicker.searchRecipientOutlets.tooltip' : 'Discover.listPicker.searchAssociatedOutlets.tooltip'"
            [(ngModel)]="searchAssociatedOutlets"
            (ngModelChange)="setDistributionRecipientSearchMode()"
            [binary]="true"
        ></agpr-checkbox>
    }
    @if (selectedList && value?.contactCount !== null) {
        <div class="agpr-discoverListFilter-contactCount">
            <span> {{ 'Discover.listPicker.totalContactsCount' | localize: {count: value?.contactCount} }} </span>
            <agpr-button
                class="agpr-discoverListFilter-viewSource"
                icon="fa-regular fa-up-right-from-square"
                [tooltip]="viewSourceTooltip"
                tooltipPosition="top"
                (click)="viewSource()"
                [initiallyFocusable]="false"
                [style]="buttonTypes.icon"
            ></agpr-button>
        </div>
    }
</div>



